const step = 0;

const reducer = (state = step, action) => {
  switch (action.type) {
    case 'set_step':
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
